import { integrationsInitialState } from '@modules/integrationsV2/store/integrationsInitialState';
import { integrationsReducer } from '@modules/integrationsV2/store/integrationsReducer';
import { create } from 'zustand';
import { devtools, redux } from 'zustand/middleware';

export const useIntegrationsStore = create(
  devtools(redux(integrationsReducer, integrationsInitialState)),
);
